export const buttonNames = {
    back: "Back",
    cancel: "Cancel",
    edit: "Edit",
    save: "Save"
};

export const fieldTypeNames = {
    dateBox: 'DateBox',
    numberBox: 'NumberBox',
    selectBox: 'SelectBox',
    textBox: 'TextBox'
};

export const formGroupNames = {
    address: 'address',
    administrative: 'administrative',
    costs: 'costs'
};